import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaUserCheck } from "react-icons/fa";
import { useHistory, withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./index.css";

import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { RootState } from "../../redux/store";
import { updateSummaryPainArea } from "../../redux/actions/authActions";
import { painAreas } from "../../services";
import SolidButton from "../../components/solid-btn";
import { PainAreaSelectionTabs } from "../profile/PainAreaSelectionTabs";
import ModalPainAreaRequest from "../dashboard/components/ModalPainAreaRequest";

function IntakeProcessSelection() {
  useDocumentTitle("Intake Process Selection");
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { user } = useSelector((state: RootState) => state.auth);
  const { summary } = user;
  const actualPA = summary.painArea || "back";
  const [intakeName, setIntakeName] = useState("intake1");
  const hasMultiplePainAreas = summary.painAreaList && summary.painAreaList.length > 1;
  const [showModalRequestPA, setShowModalRequestPA] = useState(false);

  useEffect(() => {
    if (!user?.isLoading && !summary.applicantArchived && summary.status !== "DROPPED_OUT" && summary.status !== "NOT_ACCEPTED") {
      history.push("/");
    }
  }, [summary.status, summary.applicantArchived, user?.isLoading]);

  useEffect(() => {
    const getPa = async () => {
      try {
        const result = await painAreas.get();
        const intakeSlug = result.data.find(e => e.id === summary.painArea)?.survey_type;
        setIntakeName(intakeSlug || "intake1");
      } catch {
        console.error("Error getting PA");
      }
    };
    getPa();
  }, [summary.painArea]);

  return (
    <Container fluid className={hasMultiplePainAreas ? "intake-completed-full" : "intake-completed"}>
      {hasMultiplePainAreas && (
        <PainAreaSelectionTabs
          style={{ marginLeft: "8px", paddingTop: "16px" }}
          onClick={paId => dispatch(updateSummaryPainArea(paId))}
          painAreaList={summary.painAreaList}
          userId={user.id}
          painAreaIdSelected={summary.mainPainAreaId}
          isMember
        />
      )}
      <div className={hasMultiplePainAreas ? "intake-tab-panel" : "intake-inner"}>
        <Row>
          <Col>
            <Row>
              <Col className="check-circle-container">
                <FaUserCheck />
              </Col>
            </Row>
            <Row className="title-row-intake">
              <Col>
                <h4>{t("intakeProcessSelection.review")}</h4>
              </Col>
            </Row>
            <Row>
              <Col>
                <span className="info">{t("intakeProcessSelection.looksLike")}</span>
              </Col>
            </Row>
            <br />
            <Row>
              <Col sm={{ span: 12 }} lg={{ span: 6 }} style={{ marginBottom: "16px" }}>
                <SolidButton label={"Review Prior Survey"} href={`survey/${actualPA}/${intakeName}`} state={{ samePainArea: true }} />{" "}
              </Col>
              <Col sm={{ span: 12 }} lg={{ span: 6 }}>
                <SolidButton label={"Apply for New Pain Area"} onClick={() => setShowModalRequestPA(true)} />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <ModalPainAreaRequest show={showModalRequestPA} setShow={setShowModalRequestPA} />
    </Container>
  );
}

export default withRouter(IntakeProcessSelection);
